import './App.css';

import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { StepsStyleConfig as Steps } from 'chakra-ui-steps';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';

import { ChakraButton, Navbar, View } from './components';
import { Login, PropertyInformation, Report, SignUp } from './pages';
import { AuthContextProvider } from './providers/AuthContextProvider';

const theme = extendTheme({
  components: {
    Steps,
    Button: ChakraButton
  }
});

function App() {
  return (
    <Router>
      <ChakraProvider theme={theme}>
        <AuthContextProvider>
          <View className="App">
            <Navbar />
            <Routes>
              <Route path="/" element={<Navigate to="/property-information" />} />
              <Route path="/login/*" element={<Login />} />
              <Route path="/sign-up/*" element={<SignUp />} />
              <Route path="/property-information/*" element={<PropertyInformation />} />
              <Route path="/report/*" element={<Report />} />
            </Routes>
          </View>
        </AuthContextProvider>
      </ChakraProvider>
    </Router>
  );
}

export default App;
